import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Empresa, useUsuario } from "../../../Hooks/UsuarioHook";
import { Button, TextField, Typography } from "@mui/material";
import { GerarForm } from "../../Boleto/GerarForm";
import { useIssqn } from "../../../Storage/issqn";
import ReactToPrint from "react-to-print";
import { ListagemIssqn } from "../ListagemIssqn";
import { CheckBox } from "./checkBox";
import { GerarBoleto } from "../GerarBoleto";
import { useSeletor } from "../../../Storage/seletor";
import { HeaderRelatorioImpresso } from "./HeaderRelatorioImpresso";
import { useUsuarioNaoEmiteNota } from "../../../Hooks/UsuarioNaoEmiteNotaHook";
interface Props {
  empresa?: Empresa;
}
export function RelatorioHeader({ empresa }: Props) {
  const {
    periodoFinal,
    periodoInicial,
    setPeriodoFinal,
    setPeriodoInical,
    colunas,
    getIssqnInformado,
  } = useIssqn();
  const{usuarioNaoEmiteNota} = useUsuarioNaoEmiteNota()
  const [print, setPrint] = React.useState(false);
  const { alterados, setAlterados } = useSeletor();
  const conponentRef = React.useRef(null);
  React.useEffect(() => {
    setPeriodoFinal({
      mes: new Date().getMonth() + 1,
      ano: new Date().getFullYear(),
    });

    if(periodoInicial.mes <= 1){
      setPeriodoInical({
        mes:12,
        ano: (new Date().getFullYear()-1)
      })
    }

   
  }, [empresa,usuarioNaoEmiteNota]);

  React.useEffect(() => {
    if (empresa && periodoInicial && periodoFinal)
      getIssqnInformado(
        `${periodoInicial.mes.toString().padStart(2, "0")}-${
          periodoInicial.ano
        }`,
        `${periodoFinal.mes.toString().padStart(2, "0")}-${periodoFinal.ano}`
      );
  }, [periodoInicial, periodoFinal]);




  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          width: window.screen.width > 600 ? "800px" : "100vw",

          // backgroundColor:"red",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100vw",
            flexWrap: "wrap",
            // backgroundColor:"red",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",

              // backgroundColor:"red",
            }}
          >
            <Typography variant="subtitle1" component="h3">
              Periodo Inicial
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                // backgroundColor:"red",
              }}
            >
              <FormControl style={{ width: "150px" }}>
                <TextField
                  id="filled-basic"
                  label="Mês"
                  variant="filled"
                  type={"number"}
                  value={periodoInicial.mes}
                  onChange={(ev) => {
                    let mes = Number(ev.target.value);
                    let ano = Number(periodoInicial.ano);
                    if (Number(ev.target.value) > 12) {
                      ano = ano + 1;
                      mes = 1;
                    } else if (Number(ev.target.value) < 1) {
                      ano = ano - 1;
                      mes = 12;
                    }

                    setPeriodoInical({
                      mes: mes,
                      ano: ano,
                    });
                  }}
                />
              </FormControl>
              <Typography variant="h4" component="h1">
                /
              </Typography>
              <FormControl style={{ width: "150px" }}>
                <TextField
                  id="filled-basic"
                  label="Ano"
                  variant="filled"
                  type={"number"}
                  value={periodoInicial.ano}
                  onChange={(ev) => {
                    let mes = Number(periodoInicial.mes);
                    let ano = Number(periodoInicial.ano);
                    if (Number(ev.target.value) > ano) {
                      mes = 1;
                    } else if (Number(ev.target.value) < ano) {
                      mes = 12;
                    }

                    setPeriodoInical({
                      mes: mes,
                      ano: Number(ev.target.value),
                    });
                  }}
                />
              </FormControl>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",

              // backgroundColor:"red",
            }}
          >
            <Typography variant="subtitle1" component="h3">
              Periodo Final
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                // backgroundColor:"red",
              }}
            >
              <FormControl style={{ width: "150px" }}>
                <TextField
                  id="filled-basic"
                  label="Mês"
                  variant="filled"
                  type={"number"}
                  value={periodoFinal.mes}
                  onChange={(ev) => {
                    let mes = Number(ev.target.value);
                    let ano = Number(periodoFinal.ano);
                    if (Number(ev.target.value) > 12) {
                      ano = ano + 1;
                      mes = 1;
                    } else if (Number(ev.target.value) < 1) {
                      ano = ano - 1;
                      mes = 12;
                    }

                    setPeriodoFinal({
                      mes: mes,
                      ano: ano,
                    });
                  }}
                />
              </FormControl>
              <Typography variant="h4" component="h1">
                /
              </Typography>
              <FormControl style={{ width: "150px" }}>
                <TextField
                  id="filled-basic"
                  label="Ano"
                  variant="filled"
                  type={"number"}
                  value={periodoFinal.ano}
                  onChange={(ev) => {
                    let mes = Number(periodoFinal.mes);
                    let ano = Number(periodoFinal.ano);
                    if (Number(ev.target.value) > ano) {
                      mes = 1;
                    } else if (Number(ev.target.value) < ano) {
                      mes = 12;
                    }

                    setPeriodoFinal({
                      mes: mes,

                      ano: Number(ev.target.value),
                    });
                  }}
                />
              </FormControl>
            </div>
          </div>
          <ReactToPrint
            content={() => conponentRef.current}
            trigger={() => {
              return (
                <Button variant="contained" onClick={() => {}}>
                  IMPRIMIR RESUMO
                </Button>
              );
            }}
            onBeforeGetContent={() => {
              setPrint(true);
            }}
            onAfterPrint={() => {
              setPrint(false);
            }}
          />
        </div>
      </Box>
      <br />
      {empresa ? <GerarBoleto empresa={empresa} /> : ""}
      <div hidden={!print}>
        <div ref={conponentRef}>
          <HeaderRelatorioImpresso
            empresa={empresa ? empresa : ({} as Empresa)}
            periodoInicial={periodoInicial}
            periodoFinal={periodoFinal}
          />

          <ListagemIssqn imprimir={true} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <CheckBox />
      </div>
    </>
  );
}
